const autocompleteModalFilterService = {
  site: 'Sites',
  equipments: 'Tipo do Equipamento',
  equipmentGroups: 'Grupo do Equipamento',
  place: 'Local',
  area: 'Departamento',
  serviceTypes: 'Tipo do Serviço',
  companies: 'Empresa Terceira',
  frequencies: 'Periodicidade',
  performedBy: 'Realizado por',
  doneInDelay: 'Mostrar apenas serviços que foram feitos em atraso'
};

export default autocompleteModalFilterService;
